import { useHotkeys } from 'react-hotkeys-hook';

export type FormTags = 'INPUT' | 'TEXTAREA' | 'SELECT';

type UseKeyboardShortcutOptions = {
  enabled?: boolean;
  preventDefault?: boolean;
  enableOnFormTags?: FormTags[];
  dependencies?: unknown[];
  scopes?: string | string[];
};

export const useKeyboardShortcut = (
  keys: string | string[],
  callback: (event: KeyboardEvent) => void,
  { enabled = true, preventDefault = true, enableOnFormTags, dependencies = [], scopes }: UseKeyboardShortcutOptions = {},
) => {
  const options = {
    enabled,
    preventDefault,
    enableOnFormTags,
    scopes,
  };

  useHotkeys(keys, callback, options, dependencies);
};
